// DriverContext.js
import React, { createContext, useState, useContext } from 'react';

const DriverContext = createContext();

export const DriverProvider = ({ children }) => {
  const [driverName, setDriverName] = useState({ firstName: '', lastName: '' });

  return (
    <DriverContext.Provider value={{ driverName, setDriverName }}>
      {children}
    </DriverContext.Provider>
  );
};

export const useDriverContext = () => useContext(DriverContext);